module.exports = __webpack_public_path__ + "img/checklist-button-eye.b3f15417.png";